import { render } from "./Windturbine.vue?vue&type=template&id=83c43dc4"
import script from "./Windturbine.vue?vue&type=script&lang=js"
export * from "./Windturbine.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__